module.exports = __webpack_public_path__ + "img/not-authenticated.ddbbe2e6.svg";